import { render, staticRenderFns } from "./Cupones.vue?vue&type=template&id=47f5af08&"
import script from "./Cupones.vue?vue&type=script&lang=js&"
export * from "./Cupones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports